import React, { useEffect, useState } from "react"
import Send from "../../core/communication"
import MessageScreen from "../../screen/MessageScreen"
import { customToast } from "../../components/Toast"
import { useScope, useUser } from "../SelectProjectCompanyContainer"
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"
import { db, dbtimestamp } from "../../core/firebase"
import { addItem, updateItem } from "../../core/firebase/functions"

const template = {
  title: "*Assistência*:",
  message: `*Assistência*:
 
    {{1}}
     
    👩‍🌾`,
}

const MessageContainer = ({ selectedsUsers, setMessageModalIsOpen, messageModalIsOpen }) => {
  const user = useUser()
  const [text, setText] = useState("")
  const [saving, setSaving] = useState(false)
  const [isResponseModalOpen, setIsResponseModalOpen] = useState(false)
  const [selectedUsersWithSession, setSelectedUsers] = useState([])
  const [projectList, setProjectList] = useState([])
  const [checked, setChecked] = useState([])
  const [usersFailed, setUsersFailed] = useState([])
  const [startSession, setStartSession] = useState(false)
  const [usersReceived, setUsersReceived] = useState([])
  const [sessionWhatsApp, setSessionWhatsApp] = useState({
    hasUsersToStart: false,
    started: false,
    completed: false,
  })
  const [showTemplates, setShowTemplates] = useState(false)
  const [sendOriginalTemplate, setSendOriginalTemplate] = useState(false)
  const [selectedTemplate, setSelectedTemplate] = useState({})
  const [templates, setTemplates] = useState([])
  const { scope, projectsByScope } = useScope()

  const getUsersResponse = (response = []) => {
    const usersWithErrors = response.filter((user) => user.hasError)
    const usersWithoutErrors = response.filter((user) => !user.hasError)

    setUsersFailed(usersWithErrors)
    setUsersReceived(usersWithoutErrors)
    setIsResponseModalOpen(true)
  }

  useEffect(() => {
    if (projectsByScope?.length > 0) {
      loadData(projectsByScope)
    }
  }, [projectsByScope])

  const loadData = async (projects) => {
    for (let index = 0; index < projects.length; index++) {
      const project = projects[index]
      const messages = await getMessages(project.id)
      setTemplates((old) => old.concat(messages))
    }
  }

  useEffect(() => {
    if (messageModalIsOpen && selectedsUsers && selectedsUsers.length) {
      setProjectList([...new Set(selectedsUsers.map((row) => row?.projectId))])
      setSelectedUsers(selectedsUsers)
    }

    return () => setProjectList([])
  }, [selectedsUsers, messageModalIsOpen])

  const sendMessage = async () => {
    if (selectedTemplate && selectedTemplate.message) {
      getVariables()
    } else {
      saveMessage(text)
    }
  }

  const saveMessage = async (text) => {
    if (!text || text === "") {
      customToast("Mensagem não enviada: Você deve escrever uma mensagem.", "error")
      return
    }

    if (!checked.length) {
      customToast("Mensagem não enviada: selecione ao menos um(a) produtor(a).", "error")
      return
    }

    setSaving(true)

    for await (const projectId of projectList) {
      const newUsersToSend = selectedsUsers.filter((row) => row?.projectId === projectId)

      if (projectId && newUsersToSend.length) {
        await Send.post("/message", {
          projectId,
          username: user.name,
          templateId: selectedTemplate?.templateId || 'HX84ff16014247594cb094202cc54dc45a',
          message: text,
          // selectedTemplate?.message
          //   ? text
          //   : sendOriginalTemplate
          //   ? text
          //   : template.message.replace("{{1}}", text),
          farmers: transformUsersToSendMessage(newUsersToSend, true),
          silentActiveSession: true, // showTemplates || startSession,
          envioEmMassa: true
        })
          .then((response) => {
            const formattedResponse =
              Array.isArray(response) &&
              response.map((item) => ({
                name: item?.farmerName,
                id: item?.farmerId,
                email: item?.email,
                project: item?.project,
                projectId: item?.projectId,
                hasError: item?.hasError,
                hasSession: item?.hasSession,
                groupName: item?.name,
              }))

            getUsersResponse(formattedResponse)

            customToast(
              `Mensagens enviadas para usuários do projeto "${response[0]?.project}"`,
              "success",
            )
          })
          .catch((e) => {
            customToast("Erro ao enviar mensagem", "error")
            console.log({ e })
          })
      }
    }

    setSaving(false)
  }

  const getVariables = () => {
    let defaultTemplate = selectedTemplate.message

    const hasNameVariable = /{{\s*name\s*}}/.test(defaultTemplate)

    if (hasNameVariable) {
      defaultTemplate = defaultTemplate.replace(/{{\s*name\s*}}/g, "{{1}}")
    }

    const numericMatches = [...selectedTemplate.message.matchAll(/{{(\d+)}}/g)]
    const originalNumericVariables = [...new Set(numericMatches.map((match) => match[1]))]

    const newNumericMatches = [...defaultTemplate.matchAll(/{{(\d+)}}/g)]
    const updatedNumericVariables = [...new Set(newNumericMatches.map((match) => match[1]))]

    let uniqueNumericVariables = updatedNumericVariables.filter(
      (variable) => variable !== "1" || originalNumericVariables.includes("1"),
    )

    if (uniqueNumericVariables?.length > 0) {
      withReactContent(Swal)
        .fire({
          title: "Insira as variáveis da mensagem",
          html: (
            <div>
              {uniqueNumericVariables.map((variable) => (
                <div key={variable} style={{ marginTop: "10px" }}>
                  <label>Valor para {variable}:</label>
                  <input id={`varInput-${variable}`} className="swal2-input" />
                </div>
              ))}
            </div>
          ),
          showCancelButton: true,
          confirmButtonText: "Enviar",
          confirmButtonColor: "#FF4001",
          cancelButtonText: "Cancelar",
          preConfirm: () => {
            const variables = {}

            uniqueNumericVariables.forEach((variable) => {
              variables[variable] = document.getElementById(`varInput-${variable}`).value
            })

            if (Object.values(variables).some((v) => !v)) {
              Swal.showValidationMessage("Preencha todos os campos!")
              return false
            }

            let finalMessage = defaultTemplate

            Object.entries(variables).forEach(([key, value]) => {
              const regex = new RegExp(`{{\\s*${key}\\s*}}`, "g")
              finalMessage = finalMessage.replace(regex, value)
            })

            return { finalMessage }
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            saveMessage(result.value.finalMessage)
          }
        })
    } else {
      saveMessage(defaultTemplate)
    }
  }

  const startWhatsAppSession = async () => {
    setSessionWhatsApp({
      ...sessionWhatsApp,
      started: true,
    })

    try {
      const response = await Send.post("/message/sessions/start", {
        username: user.name,
        message: text,
        farmers: transformUsersToSendMessage(selectedsUsers, true),
      })

      if (response.status && response.status === "ERROR") {
        throw new Error(response.message)
      }

      const newSelectedUsers = selectedUsersWithSession.map((item) => {
        const hasThisProducerOnResponse = response.find((row) => row.farmerId === item.farmerId)
        if (hasThisProducerOnResponse) return hasThisProducerOnResponse
        return item
      })

      setSelectedUsers(newSelectedUsers)
      setSessionWhatsApp((current) => ({ ...current, completed: true, started: false }))
    } catch (error) {
      console.log("Error", error)
      customToast("Erro ao ativar sessão.", "error")
    }
  }

  const handleCloseModal = () => {
    setIsResponseModalOpen(false)
    setMessageModalIsOpen(false)
    setSendOriginalTemplate(false)
    setShowTemplates(false)
    setSelectedTemplate({})
  }

  const onCheckedChange = (check, data) => {
    if (Array.isArray(check)) {
      setChecked(
        checked?.some((check) => data?.some((item) => item.id === check.id))
          ? checked?.filter((check) => data?.some((item) => item.id === check.id))
          : [...checked, ...data],
      )
    }
  }

  useEffect(() => {
    if (messageModalIsOpen) {
      setText("")
      setChecked(
        Array.isArray(selectedsUsers)
          ? selectedsUsers.map((item) => ({
              id: item?.farmerId || item?.id,
              name: item?.farmerName || item?.name,
            }))
          : [],
      )
    }
  }, [messageModalIsOpen])

  const transformUsersToSendMessage = (users, noChecked = false) => {
    return users
      .map((item) => {
        const filterUser = checked.find((row) => row.id === item.farmerId || row.id === item.id)

        if (noChecked && filterUser) return item
        else if (!noChecked)
          return {
            ...item,
            isChecked: filterUser,
          }
      })
      .filter((user) => user)
  }

  const handleCloseTemplateList = () => {
    setShowTemplates(false)
    setSelectedTemplate(null)
    setText("")
  }

  const handleOpenTemplateList = () => {
    setShowTemplates(true)
  }

  const toggleOriginalTemplateSending = () => {
    setSendOriginalTemplate((prevState) => !prevState)
  }

  const handleSelectedTemplate = (data) => {
    setSelectedTemplate(data)
    setText(data?.message)
  }

  const handleCreateTemplate = () => {
    withReactContent(Swal)
      .fire({
        title: "Novo template",
        html: (
          <div>
            <label style={{ display: "block", marginBottom: "5px" }}>Projeto:</label>
            <select id="projectSelect" className="swal2-input">
              {projectsByScope.map((project) => (
                <option key={project.id} value={project.id}>
                  {project.description}
                </option>
              ))}
            </select>
            <label style={{ display: "block", marginTop: "10px", marginBottom: "5px" }}>
              Título do template:
            </label>
            <input id="titleInput" className="swal2-input" />
            <label style={{ display: "block", marginTop: "10px", marginBottom: "5px" }}>
              Mensagem do template:
            </label>
            <textarea
              id="descriptionTextarea"
              className="swal2-textarea"
              placeholder={`Digite a mensagem do seu template, para dados variáveis, adicione valores como: {{1}}, {{2}}, e assim por sequência. 
Por exemplo:
Olá, {{1}}. Aqui está seu link: {{2}}`}></textarea>
          </div>
        ),
        showCancelButton: true,
        confirmButtonText: "Salvar",
        confirmButtonColor: "#FF4001",
        cancelButtonText: "Cancelar",
        preConfirm: () => {
          const project = document.getElementById("projectSelect").value
          const message = document.getElementById("descriptionTextarea").value
          const title = document.getElementById("titleInput").value

          if (!project || !message || !title) {
            Swal.showValidationMessage("Preencha todos os campos!")
            return false
          }

          return { project, message, title }
        },
      })
      .then((result) => {
        if (result.isConfirmed) {
          saveTemplate(result.value)
        }
      })
  }

  const saveTemplate = async ({ project, message, title }) => {
    const template = await addItem(`templateMessage`, {
      project,
      message,
      title,
      createdAt: dbtimestamp,
    })
    Swal.fire({
      title: "Salvo!",
      text: "Seu registro foi salvo com sucesso!",
      icon: "success",
      confirmButtonColor: "#FF4001",
    })
    setTemplates((old) => old.concat(template))
  }

  const handleDelete = async (id) => {
    const item = await updateItem(`templateMessage`, {
      id,
      active: false,
    })
    setTemplates((old) => old.filter((item) => item.id !== id))
  }

  return (
    <MessageScreen
      {...{
        handleOpenTemplateList,
        handleCloseTemplateList,
        open: messageModalIsOpen,
        selectedUsers: transformUsersToSendMessage(selectedUsersWithSession),
        handleCloseModal,
        sendMessage,
        saving,
        setText,
        text,
        sessionWhatsApp,
        startWhatsAppSession,
        countMessageFailed: usersFailed.length || 0,
        countMessageSend: usersReceived.length || 0,
        isResponseModalOpen,
        usersFailed,
        usersReceived,
        onCheckedChange,
        checked,
        setShowTemplates,
        showTemplates,
        handleSelectedTemplate,
        toggleOriginalTemplateSending,
        selectedTemplate,
        setSelectedTemplate,
        setStartSession,
        startSession,
        handleCreateTemplate,
        templates,
        handleDelete,
      }}
    />
  )
}

export default MessageContainer

const getMessages = async (id) => {
  try {
    const querySnapshot = await db
      .collection("templateMessage")
      .where("project", "==", id)
      .where("active", "==", true)
      .get()
    return querySnapshot.docs.map((doc) => doc.data())
  } catch (error) {
    console.error("Error -> ", error)
    return []
  }
}
